import React from 'react'
import { WestRewardsIconProps } from '../../../../../logos/TheWestRewardsLogo/TheWestRewardsLogo'

export const WestRewardsMovieTicketIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.8413 107.263C12.3493 105.099 12.8945 102.137 15.0592 100.646L103.619 39.6394C105.784 38.1483 108.748 38.6933 110.24 40.8567L116.492 49.9219C110.074 54.3438 108.457 63.1289 112.881 69.5441C117.305 75.9593 126.095 77.5754 132.514 73.1538L138.295 81.5359C139.787 83.6993 139.242 86.6619 137.077 88.153L48.5169 149.159C46.3523 150.65 43.388 150.105 41.896 147.942L36.1153 139.56C42.5343 135.138 44.1519 126.353 39.7276 119.937C35.3032 113.522 26.5129 111.906 20.094 116.328L13.8413 107.263Z"
                fill="#043DE2"
            />
            <path
                d="M59.6988 86.0202L69.7602 93.7147L80.1914 86.529L75.9784 98.4701L86.0398 106.165L73.3747 105.85L69.1617 117.791L65.5472 105.656L52.8821 105.341L63.3133 98.1557L59.6988 86.0202Z"
                fill="#E6ECFC"
            />
            <path
                d="M39.7058 4.76537L15.9047 96.7436L87.3081 47.5828L92.8617 26.174C93.6551 24.5882 95.2418 20.6236 95.2418 17.4519C95.2418 14.2803 93.6551 13.4873 92.8617 13.4873L83.3413 11.1086C82.8124 12.1658 81.4372 14.756 80.1678 16.659C78.581 19.0378 73.0274 21.4165 69.0606 21.4165C65.0937 21.4165 59.5401 19.0378 56.3666 14.2803C53.8278 10.4743 54.251 5.82247 54.7799 3.97233C53.9865 3.70806 52.0824 3.02095 50.813 2.38661C49.2263 1.5937 45.2594 0.80078 42.8793 1.5937C40.9752 2.22803 39.9703 3.97245 39.7058 4.76537Z"
                fill="#E6ECFC"
            />
            <path
                d="M88.1015 44.4034L33.3588 30.9238C35.21 23.5232 39.0711 7.92917 39.7058 4.7575C40.3405 1.58583 43.6727 0.792917 45.2594 0.792917L54.7799 3.17167C54.5154 3.96459 53.9865 5.86759 53.9865 7.13625C53.9865 8.72209 54.7799 11.8938 57.16 15.0654C59.5401 18.2371 63.507 20.6158 68.2672 21.4088C73.0274 22.2017 77.7877 19.03 80.1678 16.6513C82.0719 14.7483 83.6057 12.1581 84.1346 11.1008C86.2503 11.6295 90.9576 12.8453 92.8617 13.4796C94.7658 14.1139 95.2418 17.4442 95.2418 19.03L88.1015 44.4034Z"
                fill="#9BB1F3"
            />
            <path
                d="M61.133 65.8312L46.6984 75.7758L47.1132 74.1639L36.4192 67.375L49.0635 66.5851L52.2192 54.3225L56.8782 66.097L61.133 65.8312Z"
                fill="#043DE2"
            />
            <path
                d="M86.901 48.0785L94.6787 17.8551C95.1153 16.1587 94.0932 14.4297 92.3958 13.9934L83.9914 11.8331C81.2463 19.3078 73.2245 23.6321 65.3444 21.6065C57.4642 19.5809 52.5254 11.9251 53.7293 4.05433L44.5194 1.68695C42.822 1.25063 41.092 2.27217 40.6555 3.96863L16.892 96.3107L14.9005 97.6827L39.1187 3.57362C39.7736 1.02893 42.3685 -0.503376 44.9146 0.151102L55.5846 2.89377C53.643 10.4396 58.1895 18.1299 65.7396 20.0706C73.2898 22.0114 80.9846 17.4677 82.9267 9.92197L92.791 12.4576C95.3371 13.112 96.8703 15.7055 96.2155 18.2502L88.8925 46.7065L86.901 48.0785Z"
                fill="#043DE2"
            />
            <path
                d="M35.2588 31.9058L36.8169 32.3063L37.2121 30.7705L35.654 30.37L35.2588 31.9058Z"
                fill="#043DE2"
            />
            <path
                d="M39.9331 33.1073L43.0493 33.9083L43.4445 32.3725L40.3283 31.5715L39.9331 33.1073Z"
                fill="#043DE2"
            />
            <path
                d="M46.1655 34.7093L49.2817 35.5103L49.6769 33.9745L46.5607 33.1735L46.1655 34.7093Z"
                fill="#043DE2"
            />
            <path
                d="M52.3979 36.3113L55.5141 37.1124L55.9093 35.5765L52.7931 34.7755L52.3979 36.3113Z"
                fill="#043DE2"
            />
            <path
                d="M58.6303 37.9134L61.7465 38.7144L62.1417 37.1785L59.0255 36.3775L58.6303 37.9134Z"
                fill="#043DE2"
            />
            <path
                d="M64.8627 39.5154L67.9788 40.3164L68.3741 38.7805L65.2579 37.9795L64.8627 39.5154Z"
                fill="#043DE2"
            />
            <path
                d="M71.095 41.1174L74.2112 41.9184L74.6065 40.3826L71.4903 39.5815L71.095 41.1174Z"
                fill="#043DE2"
            />
            <path
                d="M77.3274 42.7194L80.4436 43.5204L80.8389 41.9846L77.7227 41.1836L77.3274 42.7194Z"
                fill="#043DE2"
            />
            <path
                d="M83.5598 44.3214L85.1179 44.7219L85.5132 43.1861L83.9551 42.7856L83.5598 44.3214Z"
                fill="#043DE2"
            />
            <path
                d="M81.9766 59.6758L111.296 100.943"
                stroke="#E6ECFC"
                strokeWidth="2"
                strokeDasharray="3 3"
            />
        </svg>
    )
}

export const WestRewardsDiningIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 137"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M84.8731 37.533C84.0442 40.9224 82.9398 44.0765 81.4849 46.3627C75.9234 55.1022 71.1421 64.6222 70.9753 79.5227H70.9708V80.3289V80.3316V131.138C70.9708 131.879 71.1322 132.583 71.4219 133.216C65.9039 135.11 59.9836 136.138 53.8232 136.138C23.8958 136.138 -0.365234 111.877 -0.365234 81.9492C-0.365234 52.0217 23.8958 27.7607 53.8232 27.7607C65.3735 27.7607 76.0798 31.3745 84.8731 37.533Z"
                fill="#9BB1F3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M90.5043 18.8637H90.5038C90.5038 23.7164 89.3715 39.2451 84.8423 46.3624C79.2808 55.1019 74.4995 64.6218 74.3326 79.5224H74.3281V80.3285V80.3312V131.137C74.3281 133.899 76.5667 136.137 79.3281 136.137H119.473C122.234 136.137 124.473 133.899 124.473 131.137L124.473 81.14L124.473 79.5224H124.46C124.191 62.0921 119.544 54.7403 113.958 46.3624C109.179 39.1925 108.322 24.9604 108.298 19.1245V1.26194C108.298 0.709658 107.85 0.26194 107.298 0.26194H91.5043C90.952 0.26194 90.5043 0.709656 90.5043 1.26194V18.8637Z"
                fill="#043DE2"
            />
            <rect
                x="74.3145"
                y="79.1387"
                width="50.1581"
                height="27.8656"
                fill="#9BB1F3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M143.446 88.0317C143.287 86.4698 142.679 83.9981 141.065 82.3839C138.639 79.9576 137.83 77.5312 137.83 71.8698C137.83 66.2083 139.448 49.2239 141.065 45.1799C141.234 44.7579 141.394 44.3535 141.547 43.9668C142.86 40.6472 143.66 38.6253 145.109 37.9009C146.346 37.2827 146.637 38.5546 146.706 40.6331L146.727 40.3271L149.044 125.312C149.104 127.493 147.352 129.293 145.171 129.293C142.942 129.293 141.173 127.419 141.302 125.195L143.446 88.0317Z"
                fill="#001D56"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M130.353 38.4238H129.179V60.4937C129.179 60.8186 128.916 61.0819 128.591 61.0819C128.266 61.0819 128.003 60.8186 128.003 60.4937V38.4238H126.09L124.473 63.4679H124.984C125.289 64.6758 127.075 66.7432 128.323 68.1875L128.323 68.1875C128.943 68.9048 129.43 69.4683 129.537 69.6967C130.032 70.7546 129.888 71.266 129.723 71.8485C129.695 71.9486 129.666 72.0509 129.64 72.1584H129.181L127.528 125.808C127.468 127.736 129.015 129.331 130.944 129.331C132.873 129.331 134.42 127.736 134.36 125.808L132.706 72.1584H132.493C132.47 72.0662 132.445 71.9772 132.42 71.8893C132.254 71.2995 132.103 70.7635 132.602 69.6967C132.772 69.3341 133.386 68.6234 134.112 67.7823L134.113 67.7823C135.335 66.367 136.876 64.5827 137.155 63.4679H137.413L134.987 38.4238H131.529V60.494C131.529 60.8188 131.266 61.0822 130.941 61.0822C130.616 61.0822 130.353 60.8188 130.353 60.494V38.4238ZM132.707 38.4238H133.884V60.4945C133.884 60.8194 133.62 61.0827 133.295 61.0827C132.97 61.0827 132.707 60.8194 132.707 60.4945V38.4238Z"
                fill="#001D56"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M90.5043 18.8638H90.5031C90.5031 23.7165 89.368 39.2433 84.8416 46.3624C81.2421 52.0239 82.7901 58.8763 86.4548 62.5381C93.7395 69.8171 105.063 69.8171 112.336 62.5381C115.571 58.4942 117.195 52.0239 113.958 46.3624C109.691 38.8984 108.343 25.0134 108.298 19.1636V1.26172C108.298 0.709435 107.85 0.261719 107.298 0.261719H91.5043C90.952 0.261719 90.5043 0.709434 90.5043 1.26172V18.8638Z"
                fill="#9BB1F3"
            />
            <circle cx="99.9501" cy="51.2723" r="5.57312" fill="#E6ECFC" />
            <path
                d="M89.9199 1C89.9199 0.447716 90.3676 0 90.9199 0H107.869C108.421 0 108.869 0.447715 108.869 1V10.0316H89.9199V1Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M77.6224 51.8783C73.5842 59.2337 70.5358 67.6783 70.4032 79.5227H70.3987V80.3289V80.3316V116.426C65.5272 118.695 60.0947 119.962 54.3663 119.962C33.3724 119.962 16.3535 102.943 16.3535 81.9493C16.3535 60.9554 33.3724 43.9365 54.3663 43.9365C63.1263 43.9365 71.1942 46.8997 77.6224 51.8783Z"
                fill="#CDD8F9"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M84.8731 37.533C76.0798 31.3745 65.3735 27.7607 53.8232 27.7607C23.8958 27.7607 -0.365234 52.0217 -0.365234 81.9492C-0.365234 111.877 23.8958 136.138 53.8232 136.138C59.9836 136.138 65.9039 135.11 71.4219 133.216C71.1322 132.583 70.9708 131.879 70.9708 131.138V131.013C65.6039 132.888 59.8342 133.908 53.8232 133.908C25.1269 133.908 1.86402 110.645 1.86402 81.9492C1.86402 53.2529 25.1269 29.99 53.8232 29.99C65.1901 29.99 75.7018 33.6381 84.2556 39.8298C84.4766 39.0818 84.6822 38.3137 84.8731 37.533Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M77.6224 51.8783C71.1942 46.8997 63.1263 43.9365 54.3663 43.9365C33.3724 43.9365 16.3535 60.9554 16.3535 81.9493C16.3535 102.943 33.3724 119.962 54.3663 119.962C60.0947 119.962 65.5272 118.695 70.3987 116.426V113.95C65.5764 116.371 60.1315 117.733 54.3663 117.733C34.6036 117.733 18.5828 101.712 18.5828 81.9493C18.5828 62.1866 34.6036 46.1658 54.3663 46.1658C62.7515 46.1658 70.4624 49.0485 76.5636 53.8804C76.9077 53.2033 77.2611 52.5364 77.6224 51.8783Z"
                fill="#043DE2"
            />
        </svg>
    )
}

export const WestRewardsWinningIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M100.728 109.751H46.2413V134.659H40.793V144H106.178V134.659H100.728V109.751Z"
                fill="#043DE2"
            />
            <rect
                x="57.1191"
                y="118.118"
                width="31.6855"
                height="12.1867"
                rx="6.09336"
                fill="#9BB1F3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.8122 16.9678H35.9139V24.2798H20.5594C20.5868 27.2658 20.9805 31.0637 21.8557 35.1032C23.0882 40.7923 25.1978 46.5946 28.2489 51.029C35.6215 61.7446 48.3034 65.8425 53.1255 67.0413L51.3614 74.1373C46.1346 72.8379 31.1818 68.1918 22.225 55.1737C18.4548 49.6941 16.0634 42.901 14.7094 36.6514C13.3589 30.4174 12.9629 24.3584 13.44 20.2064L13.8122 16.9678ZM126.581 24.2798H111.227V16.9678H133.328L133.7 20.2064C134.178 24.3584 133.782 30.4174 132.431 36.6514C131.077 42.901 128.686 49.6941 124.915 55.1737C115.959 68.1918 101.006 72.8379 95.7791 74.1373L94.0149 67.0413C98.8371 65.8425 111.519 61.7446 118.892 51.029C121.943 46.5946 124.052 40.7923 125.285 35.1032C126.16 31.0637 126.554 27.2658 126.581 24.2798Z"
                fill="#9BB1F3"
            />
            <path
                d="M33.9629 6H111.958C111.958 6 111.958 44.8338 103.714 64.569C95.4711 84.3042 82.1549 91.307 82.1549 91.307H64.4C64.4 91.307 52.9861 84.3042 43.4745 64.569C33.9629 44.8338 33.9629 6 33.9629 6Z"
                fill="#043DE2"
            />
            <path
                d="M60.7734 87.6514H86.3655C86.3655 87.6514 81.1159 93.4401 81.1159 100.515C81.1159 107.59 84.3969 110.806 84.3969 110.806H62.0859C62.0859 110.806 65.3669 108.233 65.3669 100.515C65.3669 92.7969 60.7734 87.6514 60.7734 87.6514Z"
                fill="#043DE2"
            />
            <path
                d="M72.96 25.499L76.2433 35.604H86.8683L78.2725 41.8492L81.5558 51.9542L72.96 45.709L64.3642 51.9542L67.6475 41.8492L59.0517 35.604H69.6767L72.96 25.499Z"
                fill="#CDD8F9"
            />
        </svg>
    )
}

export const WestRewardsExperienceIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="117.342"
                y="24.8955"
                width="2.84211"
                height="41.6842"
                fill="#043DE2"
            />
            <rect
                x="115.447"
                y="23.9473"
                width="6.63158"
                height="1.89474"
                fill="#043DE2"
            />
            <rect
                x="119.236"
                y="26.79"
                width="21.7895"
                height="15.1579"
                fill="#043DE2"
            />
            <path
                d="M132 33.5005L141.027 26.79V41.9479L120.5 42.0005L132 33.5005Z"
                fill="#9BB1F3"
            />
            <path
                d="M40.6582 21.8076C40.6582 20.8137 41.3881 19.9706 42.3717 19.8282L75.3717 15.0519C75.5617 15.0244 75.7547 15.0244 75.9447 15.0519L108.945 19.8282C109.928 19.9706 110.658 20.8137 110.658 21.8076V77.7895C110.658 78.8941 109.763 79.7895 108.658 79.7895H42.6582C41.5536 79.7895 40.6582 78.894 40.6582 77.7895V21.8076Z"
                fill="#9BB1F3"
                stroke="#043DE2"
                strokeWidth="2"
            />
            <path
                d="M3.6582 66.5791L75.6582 58.0527V137.632H32.5529L3.6582 66.5791Z"
                fill="#043DE2"
            />
            <path
                d="M147.658 66.5791L75.6582 58.0527V137.632H118.763L147.658 66.5791Z"
                fill="#3664E8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.6582 58.0527L147.658 66.579L145.763 71.3159L75.6582 64.6843L5.55294 71.3159L3.6582 66.5791L75.6582 58.0527Z"
                fill="#E6ECFC"
            />
            <path
                d="M147.658 66.579L148.587 66.9504L149.071 65.7394L147.776 65.586L147.658 66.579ZM75.6582 58.0527L75.7758 57.0597L75.6582 57.0457L75.5406 57.0597L75.6582 58.0527ZM145.763 71.3159L145.669 72.3114L146.414 72.3819L146.692 71.6873L145.763 71.3159ZM75.6582 64.6843L75.7524 63.6888L75.6582 63.6798L75.564 63.6888L75.6582 64.6843ZM5.55294 71.3159L4.62446 71.6873L4.90231 72.3819L5.64711 72.3115L5.55294 71.3159ZM3.6582 66.5791L3.5406 65.586L2.2453 65.7394L2.72973 66.9505L3.6582 66.5791ZM147.776 65.586L75.7758 57.0597L75.5406 59.0458L147.541 67.5721L147.776 65.586ZM146.692 71.6873L148.587 66.9504L146.73 66.2077L144.835 70.9445L146.692 71.6873ZM75.564 65.6799L145.669 72.3114L145.858 70.3203L75.7524 63.6888L75.564 65.6799ZM75.564 63.6888L5.45877 70.3203L5.64711 72.3115L75.7524 65.6799L75.564 63.6888ZM6.48142 70.9445L4.58668 66.2077L2.72973 66.9505L4.62446 71.6873L6.48142 70.9445ZM3.7758 67.5721L75.7758 59.0458L75.5406 57.0597L3.5406 65.586L3.7758 67.5721Z"
                fill="#043DE2"
            />
            <rect
                x="45.3418"
                y="25.8418"
                width="30.3158"
                height="18"
                fill="#9BB1F3"
            />
            <mask id="path-11-inside-1_3102_21777" fill="white">
                <rect
                    x="76.6055"
                    y="25.8418"
                    width="30.3158"
                    height="18"
                    rx="1"
                />
            </mask>
            <rect
                x="76.6055"
                y="25.8418"
                width="30.3158"
                height="18"
                rx="1"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="4"
                mask="url(#path-11-inside-1_3102_21777)"
            />
            <mask id="path-12-inside-2_3102_21777" fill="white">
                <rect
                    x="44.3945"
                    y="25.8418"
                    width="30.3158"
                    height="18"
                    rx="1"
                />
            </mask>
            <rect
                x="44.3945"
                y="25.8418"
                width="30.3158"
                height="18"
                rx="1"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="4"
                mask="url(#path-12-inside-2_3102_21777)"
            />
        </svg>
    )
}

export const WestRewardsEBookIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 0C31.4772 0 27 4.47715 27 10V25.4101C31.0089 24.0891 36.1651 23 42.5 23C57.3 23 70.3333 27.8566 75 31.5C79.6667 27.8566 92.7 23 107.5 23C114.375 23 119.861 24.2826 124 25.7524V10C124 4.47715 119.523 0 114 0H37ZM124 117.508C119.072 116.101 113.103 115 107.5 115C95 115 81 122.672 75 129C69 122.672 55 115 42.5 115C37.2711 115 31.7232 115.959 27 117.23V131C27 136.523 31.4772 141 37 141H114C119.523 141 124 136.523 124 131V117.508Z"
                fill="#E6ECFC"
            />
            <path
                d="M75 41.5V125C68.5862 119.5 53.6207 112 40.2586 112C29.569 112 17.6322 116.333 13 118.5V38C15.4943 37.1667 24.4379 32 40.2586 32C56.0793 32 70.0115 38.3333 75 41.5Z"
                fill="#9BB1F3"
            />
            <path
                d="M75 41.5V125C81.5172 119.5 96.7241 112 110.302 112C121.164 112 133.293 116.333 138 118.5V38C135.466 37.1667 126.378 32 110.302 32C94.2259 32 80.069 38.3333 75 41.5Z"
                fill="#9BB1F3"
            />
            <path
                d="M75 35.5V119C69 113.5 55 106 42.5 106C32.5 106 21.3333 110.333 17 112.5V32C19.3333 31.1667 27.7 26 42.5 26C57.3 26 70.3333 32.3333 75 35.5Z"
                fill="#043DE2"
            />
            <path
                d="M75 35.5V119C81 113.5 95 106 107.5 106C117.5 106 128.667 110.333 133 112.5V32C130.667 31.1667 122.3 26 107.5 26C92.7 26 79.6667 32.3333 75 35.5Z"
                fill="#3664E8"
            />
            <path
                d="M75 35.5V119C69 113.5 55 106 42.5 106C32.5 106 21.3333 110.333 17 112.5V32C19.3333 31.1667 27.7 26 42.5 26C57.3 26 70.3333 32.3333 75 35.5Z"
                fill="#043DE2"
            />
            <path
                d="M75 35.5V119C81 113.5 95 106 107.5 106C117.5 106 128.667 110.333 133 112.5V32C130.667 31.1667 122.3 26 107.5 26C92.7 26 79.6667 32.3333 75 35.5Z"
                fill="#3664E8"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M47 17H104C107.789 17 110.963 19.6344 111.79 23.1715C112.501 23.2291 113.194 23.3002 113.87 23.3832C113.097 18.6292 108.972 15 104 15H47C42.0676 15 37.9693 18.571 37.1493 23.2686C37.8251 23.1996 38.5177 23.1426 39.2272 23.0992C40.0803 19.5985 43.2367 17 47 17ZM39 115.497C38.3336 115.525 37.6662 115.562 37 115.605V116C37 121.523 41.4772 126 47 126H71.6524C70.7863 125.326 69.8486 124.656 68.8501 124H47C42.5817 124 39 120.418 39 116V115.497ZM81.1499 124C80.1514 124.656 79.2137 125.326 78.3476 126H104C109.523 126 114 121.523 114 116V115.676C113.335 115.625 112.668 115.582 112 115.545V116C112 120.418 108.418 124 104 124H81.1499Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M37 2H114C118.418 2 122 5.58172 122 10V25.054C122.698 25.2628 123.365 25.4797 124 25.701V10C124 4.47715 119.523 0 114 0H37C31.4772 0 27 4.47715 27 10V25.3651C27.6376 25.1589 28.3042 24.9585 29 24.7672V10C29 5.58172 32.5817 2 37 2ZM29 116.655C28.3199 116.804 27.6522 116.961 27 117.123V131C27 136.523 31.4772 141 37 141H114C119.523 141 124 136.523 124 131V117.523C123.35 117.366 122.683 117.216 122 117.072V131C122 135.418 118.418 139 114 139H37C32.5817 139 29 135.418 29 131V116.655Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M123.216 73.6743C121.277 72.9673 115.264 70.7749 106.555 71.7425C102.04 72.2442 97.2087 73.6462 93.0022 75.2802C88.7919 76.9155 85.2437 78.769 83.289 80.1536C83.0637 80.3132 82.7516 80.2599 82.592 80.0346C82.4324 79.8093 82.4857 79.4972 82.711 79.3376C84.7564 77.8888 88.3863 76.0003 92.6401 74.348C96.8977 72.6943 101.816 71.2629 106.445 70.7486C115.385 69.7553 121.573 72.0109 123.559 72.735C123.598 72.7492 123.635 72.7627 123.671 72.7757C123.93 72.8701 124.064 73.1569 123.97 73.4165C123.876 73.676 123.589 73.8099 123.329 73.7155C123.293 73.7024 123.256 73.6887 123.216 73.6743Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M123.216 77.6743C121.277 76.9673 115.264 74.7749 106.555 75.7425C102.04 76.2442 97.2087 77.6462 93.0022 79.2802C88.7919 80.9155 85.2437 82.769 83.289 84.1536C83.0637 84.3132 82.7516 84.2599 82.592 84.0346C82.4324 83.8093 82.4857 83.4972 82.711 83.3376C84.7564 81.8888 88.3863 80.0003 92.6401 78.348C96.8977 76.6943 101.816 75.2629 106.445 74.7486C115.385 73.7553 121.573 76.0109 123.559 76.735C123.598 76.7492 123.635 76.7627 123.671 76.7757C123.93 76.8701 124.064 77.1569 123.97 77.4165C123.876 77.676 123.589 77.8099 123.329 77.7155C123.293 77.7024 123.256 77.6887 123.216 77.6743Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M123.216 81.6743C121.277 80.9673 115.264 78.7749 106.555 79.7425C102.04 80.2442 97.2087 81.6462 93.0022 83.2802C88.7919 84.9155 85.2437 86.769 83.289 88.1536C83.0637 88.3132 82.7516 88.2599 82.592 88.0346C82.4324 87.8093 82.4857 87.4972 82.711 87.3376C84.7564 85.8888 88.3863 84.0003 92.6401 82.348C96.8977 80.6943 101.816 79.2629 106.445 78.7486C115.385 77.7553 121.573 80.0109 123.559 80.735C123.598 80.7492 123.635 80.7627 123.671 80.7757C123.93 80.8701 124.064 81.1569 123.97 81.4165C123.876 81.676 123.589 81.8099 123.329 81.7155C123.293 81.7024 123.256 81.6887 123.216 81.6743Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M116.329 84.4696C114.585 83.8355 110.499 83.3041 106.555 83.7424C102.04 84.2443 97.2087 85.6463 93.0022 87.2802C88.7919 88.9155 85.2437 90.7689 83.289 92.1535C83.0637 92.3131 82.7516 92.2598 82.592 92.0345C82.4324 91.8092 82.4857 91.4971 82.711 91.3375C84.7564 89.8887 88.3863 88.0003 92.6401 86.348C96.8977 84.6943 101.816 83.2629 106.445 82.7486C110.501 82.2978 114.748 82.8306 116.671 83.5298C116.93 83.6242 117.064 83.911 116.97 84.1706C116.876 84.4301 116.589 84.564 116.329 84.4696Z"
                fill="white"
            />
            <rect x="71" y="132" width="10" height="3" rx="1" fill="#9BB1F3" />
        </svg>
    )
}

export const WestRewardsNewsletterIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.6364 6H116V110.369C116 118.449 109.469 125 101.413 125H10L17.0083 55.4375H19.6364V6Z"
                fill="#E6ECFC"
            />
            <path
                d="M30 17.8919C30 16.847 30.8683 16 31.9394 16H60.0606C61.1317 16 62 16.847 62 17.8919V49.1081C62 50.153 61.1317 51 60.0606 51H31.9394C30.8683 51 30 50.153 30 49.1081V17.8919Z"
                fill="#9BB1F3"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M60.0606 17.8919H31.9394V49.1081H60.0606V17.8919ZM31.9394 16C30.8683 16 30 16.847 30 17.8919V49.1081C30 50.153 30.8683 51 31.9394 51H60.0606C61.1317 51 62 50.153 62 49.1081V17.8919C62 16.847 61.1317 16 60.0606 16H31.9394Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M68 31C68 30.4477 68.4362 30 68.9744 30L105.026 30C105.564 30 106 30.4477 106 31C106 31.5523 105.564 32 105.026 32L68.9744 32C68.4362 32 68 31.5523 68 31Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29 60C29 59.4477 29.4364 59 29.9747 59L105.025 59C105.564 59 106 59.4477 106 60C106 60.5523 105.564 61 105.025 61L29.9747 61C29.4364 61 29 60.5523 29 60Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M68 40C68 39.4477 68.4362 39 68.9744 39L105.026 39C105.564 39 106 39.4477 106 40C106 40.5523 105.564 41 105.026 41L68.9744 41C68.4362 41 68 40.5523 68 40Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M29 69C29 68.4477 29.4364 68 29.9747 68L105.025 68C105.564 68 106 68.4477 106 69C106 69.5523 105.564 70 105.025 70L29.9747 70C29.4364 70 29 69.5523 29 69Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M68 48C68 47.4477 68.4362 47 68.9744 47L105.026 47C105.564 47 106 47.4477 106 48C106 48.5523 105.564 49 105.026 49L68.9744 49C68.4362 49 68 48.5523 68 48Z"
                fill="#043DE2"
            />
            <path
                d="M74.7701 142L68.631 107.68L66 98L148 65L74.7701 142Z"
                fill="#9BB1F3"
            />
            <path d="M74 141L81.2453 115.054L122 109L74 141Z" fill="#CDD8F9" />
            <path d="M82 114.92L148 66L122.48 142L82 114.92Z" fill="#043DE2" />
            <path d="M148 65L37 90.7113L68.9016 108L148 65Z" fill="#043DE2" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.698 55.2357H19.3232V6H115.583V70.6607L113.64 71.1059V7.94286H21.2661V57.1786H18.4544L11.8463 122.571H67.7925L68.1538 124.514H9.69727L16.698 55.2357ZM98.7448 124.514H101.012C109.059 124.514 115.583 117.99 115.583 109.943V106.898L113.64 109.539V109.943C113.64 115.792 109.663 120.713 104.266 122.148L98.7448 124.514Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M54.7412 103.143L58.2484 105.085L30.0964 105.085C29.5599 105.085 29.125 104.651 29.125 104.114C29.125 103.578 29.5599 103.143 30.0964 103.143L54.7412 103.143Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M38.9591 94.4004L42.4663 96.3432L30.0964 96.3432C29.5599 96.3432 29.125 95.9083 29.125 95.3718C29.125 94.8353 29.5599 94.4004 30.0964 94.4004L38.9591 94.4004Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M50.1436 85.6572L30.0964 85.6572C29.5599 85.6572 29.125 86.0922 29.125 86.6287C29.125 87.1652 29.5599 87.6001 30.0964 87.6001L41.6657 87.6001L50.1436 85.6572ZM103.822 87.6001L105.855 86.4732C105.864 86.5238 105.868 86.5757 105.868 86.6287C105.868 87.1652 105.433 87.6001 104.896 87.6001H103.822Z"
                fill="#043DE2"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M88.2938 76.9141L79.8159 78.8569L30.0964 78.8569C29.5599 78.8569 29.125 78.422 29.125 77.8855C29.125 77.349 29.5599 76.9141 30.0964 76.9141L88.2938 76.9141Z"
                fill="#043DE2"
            />
            <path
                d="M3 55H20V115.5C20 120.194 16.1944 124 11.5 124C6.80558 124 3 120.194 3 115.5V55Z"
                fill="#9BB1F3"
                stroke="#043DE2"
                strokeWidth="2"
            />
        </svg>
    )
}

export const WestRewardsVideoPodcastIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="150" height="150" fill="white" />
            <rect
                x="8"
                y="26.5"
                width="134"
                height="78.5"
                rx="4"
                fill="#043DE2"
            />
            <rect
                x="2.5"
                y="106"
                width="145"
                height="9"
                rx="4"
                fill="#043DE2"
            />
            <path
                d="M7.40774 103.129C7.7857 102.728 8.31269 102.5 8.86415 102.5H141.136C141.687 102.5 142.214 102.728 142.592 103.129L146.828 107.629C148.029 108.906 147.124 111 145.371 111H4.62885C2.87611 111 1.97118 108.906 3.17245 107.629L7.40774 103.129Z"
                fill="#043DE2"
            />
            <path
                d="M11.4313 104.126C11.5228 104.045 11.6409 104 11.7631 104H138.722C138.853 104 138.979 104.052 139.073 104.144L142.63 107.644C142.949 107.957 142.726 108.5 142.279 108.5H7.8172C7.35718 108.5 7.14127 107.931 7.48542 107.626L11.4313 104.126Z"
                fill="#9BB1F3"
            />
            <rect
                x="12"
                y="30.5"
                width="126"
                height="70.5"
                rx="1"
                fill="#9BB1F3"
            />
            <rect
                x="61"
                y="107"
                width="28"
                height="4.5"
                rx="2"
                fill="#043DE2"
            />
            <rect
                x="114.25"
                y="58.75"
                width="11.5"
                height="19"
                rx="5.75"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="1.5"
            />
            <path
                d="M115.276 79.5294C115.276 78.4177 114.384 77.5 113.263 77.5C112.142 77.5 111.25 78.4177 111.25 79.5294V80.3824C111.25 83.8494 114.027 86.6765 117.474 86.6765H117.987V89.4412H113.263C112.142 89.4412 111.25 90.3588 111.25 91.4706C111.25 92.5823 112.142 93.5 113.263 93.5H126.737C127.858 93.5 128.75 92.5823 128.75 91.4706C128.75 90.3588 127.858 89.4412 126.737 89.4412H122.013V86.6765H122.526C125.973 86.6765 128.75 83.8494 128.75 80.3824V79.5294C128.75 78.4177 127.858 77.5 126.737 77.5C125.616 77.5 124.724 78.4177 124.724 79.5294V80.3824C124.724 81.6259 123.731 82.6176 122.526 82.6176H117.474C116.269 82.6176 115.276 81.6259 115.276 80.3824V79.5294Z"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="20"
                y="39.5"
                width="35"
                height="29.2727"
                rx="2.54545"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="1.90909"
            />
            <path
                d="M43.5455 57.7309C43.9697 57.9717 43.9697 58.5738 43.5455 58.8146L34 64.2334C33.5758 64.4743 33.0455 64.1732 33.0455 63.6916L33.0455 52.8539C33.0455 52.3723 33.5758 52.0712 34 52.3121L43.5455 57.7309Z"
                fill="#043DE2"
            />
            <line
                x1="20"
                y1="47.4546"
                x2="55"
                y2="47.4546"
                stroke="#043DE2"
                strokeWidth="1.90909"
            />
            <line
                x1="21.8705"
                y1="47.2523"
                x2="29.5201"
                y2="39.6027"
                stroke="#043DE2"
                strokeWidth="1.90909"
            />
            <line
                x1="29.5069"
                y1="47.2523"
                x2="37.1565"
                y2="39.6027"
                stroke="#043DE2"
                strokeWidth="1.90909"
            />
            <line
                x1="37.1432"
                y1="47.2523"
                x2="44.7928"
                y2="39.6027"
                stroke="#043DE2"
                strokeWidth="1.90909"
            />
            <line
                x1="44.7796"
                y1="47.2523"
                x2="52.4292"
                y2="39.6027"
                stroke="#043DE2"
                strokeWidth="1.90909"
            />
            <line
                x1="65.5"
                y1="40.5"
                x2="129.5"
                y2="40.5"
                stroke="#043DE2"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="65.5"
                y1="49.5"
                x2="129.5"
                y2="49.5"
                stroke="#043DE2"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="65.5"
                y1="58.5"
                x2="102"
                y2="58.5"
                stroke="#043DE2"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="65.5"
                y1="67.5"
                x2="102"
                y2="67.5"
                stroke="#043DE2"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="21"
                y1="76.5"
                x2="102"
                y2="76.5"
                stroke="#043DE2"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="21"
                y1="85.5"
                x2="102"
                y2="85.5"
                stroke="#043DE2"
                strokeWidth="2"
                strokeLinecap="round"
            />
            <line
                x1="21"
                y1="94.5"
                x2="102"
                y2="94.5"
                stroke="#043DE2"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    )
}

export const WestRewardsDollarIcon = (props: WestRewardsIconProps) => {
    const idSuffix = Math.random().toString().replace('.', '-')
    return (
        <svg
            width={props.width}
            height={props.height}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="150" height="150" fill="white" />
            <circle
                cx="74.5429"
                cy="75.0002"
                r="61.3238"
                fill="#9BB1F3"
                stroke="#043DE2"
                strokeWidth="5.21905"
            />
            <mask
                id={`path-2-outside-1_3443_25591-${idSuffix}`}
                maskUnits="userSpaceOnUse"
                x="41.7632"
                y="28.5522"
                width="66"
                height="92"
                fill="black"
            >
                <rect
                    fill="white"
                    x="41.7632"
                    y="28.5522"
                    width="66"
                    height="92"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M75.1952 34.5522C73.3937 34.5522 71.9333 36.0126 71.9333 37.8141V41.7001C68.2349 42.0095 64.8748 42.8232 61.8529 44.1413C57.9251 45.8637 54.8479 48.2687 52.6214 51.3564C50.4159 54.4231 49.3236 58.0044 49.3446 62.1003C49.3236 67.1414 50.9515 71.1218 54.2282 74.0415C57.526 76.9401 62.0315 79.0091 67.7448 80.2483L71.9333 81.1518V93.0456C71.0729 92.8738 70.2754 92.6304 69.5407 92.3155C67.9443 91.6224 66.705 90.6037 65.8228 89.2593C65.2298 88.3557 64.8124 87.3097 64.5706 86.1214C64.363 85.1018 63.5267 84.2812 62.4862 84.2812H49.6711C48.5872 84.2812 47.703 85.1629 47.7664 86.2449C48.0313 90.7638 49.1665 94.5412 51.1721 97.5772C53.4826 101.022 56.7173 103.574 60.8762 105.233C64.1294 106.525 67.8151 107.314 71.9333 107.6V111.533C71.9333 113.335 73.3937 114.795 75.1952 114.795C76.9967 114.795 78.4571 113.335 78.4571 111.533V107.647C82.6919 107.419 86.3993 106.677 89.5791 105.422C93.486 103.889 96.4897 101.652 98.5901 98.7115C100.691 95.7708 101.751 92.179 101.772 87.9361C101.751 85.4785 101.352 83.21 100.575 81.1305C99.8189 79.0511 98.6322 77.1817 97.0148 75.5223C95.3974 73.8419 93.318 72.3821 90.7764 71.1428C88.2348 69.9035 85.1787 68.9058 81.6079 68.1496L78.4571 67.4745V56.2009C79.8247 56.4822 80.9274 56.9783 81.7654 57.6893C82.7481 58.5107 83.4287 59.5574 83.8071 60.8295C84.0981 61.8075 84.9149 62.6044 85.9352 62.6044H98.9233C100.008 62.6044 100.895 61.7206 100.803 60.6399C100.511 57.2289 99.4898 54.1974 97.7395 51.5454C95.681 48.3737 92.7508 45.9162 88.949 44.1728C85.9033 42.7761 82.406 41.9389 78.4571 41.6611V37.8142C78.4571 36.0127 76.9967 34.5522 75.1952 34.5522ZM71.9333 56.2931C71.5979 56.3767 71.2834 56.4745 70.99 56.5865C69.8557 57.0066 69.0155 57.5843 68.4694 58.3194C67.9233 59.0546 67.6397 59.8948 67.6187 60.84C67.5767 61.6172 67.7132 62.3208 68.0283 62.951C68.3644 63.5601 68.8895 64.1167 69.6037 64.6208C70.2278 65.0431 71.0044 65.4332 71.9333 65.7912V56.2931ZM78.4571 82.793V93.084C79.0145 92.9758 79.5291 92.8351 80.001 92.6621C81.2613 92.2 82.217 91.5594 82.8681 90.7402C83.5193 89.921 83.8554 88.9863 83.8764 87.9361C83.8554 86.9488 83.5298 86.0876 82.8996 85.3525C82.2905 84.5963 81.2823 83.9242 79.875 83.336C79.4478 83.1511 78.9752 82.9701 78.4571 82.793Z"
                />
            </mask>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M75.1952 34.5522C73.3937 34.5522 71.9333 36.0126 71.9333 37.8141V41.7001C68.2349 42.0095 64.8748 42.8232 61.8529 44.1413C57.9251 45.8637 54.8479 48.2687 52.6214 51.3564C50.4159 54.4231 49.3236 58.0044 49.3446 62.1003C49.3236 67.1414 50.9515 71.1218 54.2282 74.0415C57.526 76.9401 62.0315 79.0091 67.7448 80.2483L71.9333 81.1518V93.0456C71.0729 92.8738 70.2754 92.6304 69.5407 92.3155C67.9443 91.6224 66.705 90.6037 65.8228 89.2593C65.2298 88.3557 64.8124 87.3097 64.5706 86.1214C64.363 85.1018 63.5267 84.2812 62.4862 84.2812H49.6711C48.5872 84.2812 47.703 85.1629 47.7664 86.2449C48.0313 90.7638 49.1665 94.5412 51.1721 97.5772C53.4826 101.022 56.7173 103.574 60.8762 105.233C64.1294 106.525 67.8151 107.314 71.9333 107.6V111.533C71.9333 113.335 73.3937 114.795 75.1952 114.795C76.9967 114.795 78.4571 113.335 78.4571 111.533V107.647C82.6919 107.419 86.3993 106.677 89.5791 105.422C93.486 103.889 96.4897 101.652 98.5901 98.7115C100.691 95.7708 101.751 92.179 101.772 87.9361C101.751 85.4785 101.352 83.21 100.575 81.1305C99.8189 79.0511 98.6322 77.1817 97.0148 75.5223C95.3974 73.8419 93.318 72.3821 90.7764 71.1428C88.2348 69.9035 85.1787 68.9058 81.6079 68.1496L78.4571 67.4745V56.2009C79.8247 56.4822 80.9274 56.9783 81.7654 57.6893C82.7481 58.5107 83.4287 59.5574 83.8071 60.8295C84.0981 61.8075 84.9149 62.6044 85.9352 62.6044H98.9233C100.008 62.6044 100.895 61.7206 100.803 60.6399C100.511 57.2289 99.4898 54.1974 97.7395 51.5454C95.681 48.3737 92.7508 45.9162 88.949 44.1728C85.9033 42.7761 82.406 41.9389 78.4571 41.6611V37.8142C78.4571 36.0127 76.9967 34.5522 75.1952 34.5522ZM71.9333 56.2931C71.5979 56.3767 71.2834 56.4745 70.99 56.5865C69.8557 57.0066 69.0155 57.5843 68.4694 58.3194C67.9233 59.0546 67.6397 59.8948 67.6187 60.84C67.5767 61.6172 67.7132 62.3208 68.0283 62.951C68.3644 63.5601 68.8895 64.1167 69.6037 64.6208C70.2278 65.0431 71.0044 65.4332 71.9333 65.7912V56.2931ZM78.4571 82.793V93.084C79.0145 92.9758 79.5291 92.8351 80.001 92.6621C81.2613 92.2 82.217 91.5594 82.8681 90.7402C83.5193 89.921 83.8554 88.9863 83.8764 87.9361C83.8554 86.9488 83.5298 86.0876 82.8996 85.3525C82.2905 84.5963 81.2823 83.9242 79.875 83.336C79.4478 83.1511 78.9752 82.9701 78.4571 82.793Z"
                fill="#E6ECFC"
            />
            <path
                d="M71.9333 41.7001L72.3685 46.901L77.1524 46.5007V41.7001H71.9333ZM61.8529 44.1413L59.7664 39.3575L59.757 39.3616L61.8529 44.1413ZM52.6214 51.3564L48.3881 48.3038L48.3843 48.3092L52.6214 51.3564ZM49.3446 62.1003L54.5637 62.122L54.5638 62.0978L54.5636 62.0735L49.3446 62.1003ZM54.2282 74.0415L50.7562 77.9381L50.7694 77.9498L50.7826 77.9614L54.2282 74.0415ZM67.7448 80.2483L66.6384 85.3488L66.6444 85.3501L67.7448 80.2483ZM71.9333 81.1518H77.1524V76.9384L73.0337 76.05L71.9333 81.1518ZM71.9333 93.0456L70.9112 98.1636L77.1524 99.4101V93.0456H71.9333ZM69.5407 92.3155L67.462 97.1028L67.4734 97.1077L67.4848 97.1126L69.5407 92.3155ZM65.8228 89.2593L70.1862 86.3959L70.1862 86.3959L65.8228 89.2593ZM64.5706 86.1214L59.4563 87.1622L59.4563 87.1622L64.5706 86.1214ZM47.7664 86.2449L42.5563 86.5503L47.7664 86.2449ZM51.1721 97.5772L46.8174 100.454L46.8275 100.469L46.8377 100.484L51.1721 97.5772ZM60.8762 105.233L58.9421 110.081L58.9505 110.084L60.8762 105.233ZM71.9333 107.6H77.1524V102.731L72.2953 102.394L71.9333 107.6ZM78.4571 107.647L78.1766 102.435L73.2381 102.701V107.647H78.4571ZM89.5791 105.422L87.6724 100.564L87.6635 100.568L89.5791 105.422ZM98.5901 98.7115L94.3432 95.6779L94.3432 95.678L98.5901 98.7115ZM101.772 87.9361L106.991 87.9619L106.992 87.9267L106.991 87.8914L101.772 87.9361ZM100.575 81.1305L95.6703 82.9141L95.6782 82.9359L95.6863 82.9576L100.575 81.1305ZM97.0148 75.5223L93.2545 79.1415L93.2659 79.1534L93.2774 79.1651L97.0148 75.5223ZM81.6079 68.1496L80.5143 73.2528L80.5266 73.2555L81.6079 68.1496ZM78.4571 67.4745H73.2381V71.6936L77.3636 72.5777L78.4571 67.4745ZM78.4571 56.2009L79.5084 51.0889L73.2381 49.7994V56.2009H78.4571ZM81.7654 57.6893L78.3888 61.6689L78.4035 61.6814L78.4184 61.6938L81.7654 57.6893ZM83.8071 60.8295L88.8095 59.3414L88.8095 59.3414L83.8071 60.8295ZM100.803 60.6399L95.6028 61.0849V61.0849L100.803 60.6399ZM97.7395 51.5454L93.3616 54.3867L93.3725 54.4035L93.3836 54.4203L97.7395 51.5454ZM88.949 44.1728L86.7735 48.9168V48.9168L88.949 44.1728ZM78.4571 41.6611H73.2381V46.526L78.0909 46.8673L78.4571 41.6611ZM71.9333 56.2931H77.1524V49.6141L70.6715 51.2289L71.9333 56.2931ZM70.99 56.5865L72.8026 61.4807L72.8272 61.4716L72.8516 61.4623L70.99 56.5865ZM68.4694 58.3194L72.659 61.4317L72.659 61.4317L68.4694 58.3194ZM67.6187 60.84L72.8302 61.1217L72.8346 61.0389L72.8365 60.956L67.6187 60.84ZM68.0283 62.951L63.3603 65.285L63.4076 65.3796L63.4586 65.4722L68.0283 62.951ZM69.6037 64.6208L66.5939 68.8846L66.6364 68.9146L66.6794 68.9437L69.6037 64.6208ZM71.9333 65.7912L70.0564 70.6611L77.1524 73.396V65.7912H71.9333ZM78.4571 82.793L80.1456 77.8546L73.2381 75.4928V82.793H78.4571ZM78.4571 93.084H73.2381V99.4142L79.4522 98.2073L78.4571 93.084ZM80.001 92.6621L81.7977 97.5621L80.001 92.6621ZM82.8681 90.7402L78.7826 87.4926L78.7825 87.4927L82.8681 90.7402ZM83.8764 87.9361L89.0944 88.0404L89.0965 87.9327L89.0942 87.825L83.8764 87.9361ZM82.8996 85.3525L78.8353 88.6265L78.8852 88.6885L78.937 88.749L82.8996 85.3525ZM79.875 83.336L77.8019 88.1257L77.8321 88.1388L77.8625 88.1515L79.875 83.336ZM77.1524 37.8141C77.1524 38.8951 76.2761 39.7713 75.1952 39.7713V29.3332C70.5113 29.3332 66.7143 33.1302 66.7143 37.8141H77.1524ZM77.1524 41.7001V37.8141H66.7143V41.7001H77.1524ZM63.9395 48.9251C66.3761 47.8623 69.1689 47.1686 72.3685 46.901L71.4982 36.4992C67.301 36.8503 63.3736 37.7841 59.7664 39.3575L63.9395 48.9251ZM56.8546 54.4089C58.4692 52.1698 60.7644 50.3174 63.9489 48.921L59.757 39.3616C55.0858 41.4099 51.2265 44.3676 48.3881 48.3038L56.8546 54.4089ZM54.5636 62.0735C54.5478 58.9821 55.3518 56.4985 56.8585 54.4036L48.3843 48.3092C45.4799 52.3476 44.0995 57.0267 44.1257 62.127L54.5636 62.0735ZM57.7002 70.1448C55.7121 68.3733 54.5479 65.9132 54.5637 62.122L44.1256 62.0785C44.0994 68.3696 46.1909 73.8703 50.7562 77.9381L57.7002 70.1448ZM68.8511 75.1479C63.728 74.0366 60.1201 72.2716 57.6738 70.1215L50.7826 77.9614C54.9319 81.6085 60.335 83.9815 66.6384 85.3488L68.8511 75.1479ZM73.0337 76.05L68.8451 75.1466L66.6444 85.3501L70.833 86.2535L73.0337 76.05ZM77.1524 93.0456V81.1518H66.7143V93.0456H77.1524ZM67.4848 97.1126C68.5825 97.583 69.7301 97.9277 70.9112 98.1636L72.9555 87.9276C72.4158 87.8198 71.9682 87.6778 71.5965 87.5185L67.4848 97.1126ZM61.4595 92.1228C62.9457 94.3875 65.0132 96.0395 67.462 97.1028L71.6193 87.5283C70.8754 87.2053 70.4644 86.8198 70.1862 86.3959L61.4595 92.1228ZM59.4563 87.1622C59.8143 88.9213 60.4609 90.6012 61.4595 92.1228L70.1862 86.3959C69.9987 86.1102 69.8105 85.6982 69.6848 85.0806L59.4563 87.1622ZM62.4862 89.5003C60.5779 89.5003 59.644 88.0845 59.4563 87.1622L69.6848 85.0806C69.0821 82.1191 66.4755 79.0622 62.4862 79.0622V89.5003ZM49.6711 89.5003H62.4862V79.0622H49.6711V89.5003ZM52.9765 85.9396C53.1001 88.0478 51.3929 89.5003 49.6711 89.5003V79.0622C45.7815 79.0622 42.3059 82.2781 42.5563 86.5503L52.9765 85.9396ZM55.5267 94.7005C54.1375 92.5975 53.2006 89.7626 52.9765 85.9396L42.5563 86.5503C42.8619 91.765 44.1955 96.4849 46.8174 100.454L55.5267 94.7005ZM62.8103 100.386C59.5472 99.084 57.1836 97.1706 55.5064 94.67L46.8377 100.484C49.7815 104.873 53.8874 108.064 58.9421 110.081L62.8103 100.386ZM72.2953 102.394C68.6199 102.138 65.4749 101.444 62.8019 100.383L58.9505 110.084C62.7838 111.606 67.0102 112.489 71.5713 112.807L72.2953 102.394ZM77.1524 111.533V107.6H66.7143V111.533H77.1524ZM75.1952 109.576C76.2761 109.576 77.1524 110.452 77.1524 111.533H66.7143C66.7143 116.217 70.5113 120.014 75.1952 120.014V109.576ZM73.2381 111.533C73.2381 110.452 74.1143 109.576 75.1952 109.576V120.014C79.8791 120.014 83.6762 116.217 83.6762 111.533H73.2381ZM73.2381 107.647V111.533H83.6762V107.647H73.2381ZM87.6635 100.568C85.1141 101.574 81.9801 102.23 78.1766 102.435L78.7377 112.858C83.4038 112.607 87.6844 111.781 91.4948 110.277L87.6635 100.568ZM94.3432 95.678C92.9197 97.6709 90.7942 99.339 87.6724 100.564L91.4859 110.281C96.1778 108.439 100.06 105.633 102.837 101.745L94.3432 95.678ZM96.5534 87.9102C96.5368 91.2674 95.7129 93.7604 94.3432 95.6779L102.837 101.745C105.668 97.7812 106.966 93.0906 106.991 87.9619L96.5534 87.9102ZM95.6863 82.9576C96.2287 84.4089 96.5371 86.0671 96.5535 87.9807L106.991 87.8914C106.966 84.8899 106.476 82.0111 105.464 79.3034L95.6863 82.9576ZM93.2774 79.1651C94.4031 80.3201 95.1789 81.563 95.6703 82.9141L105.48 79.347C104.459 76.5392 102.861 74.0432 100.752 71.8795L93.2774 79.1651ZM88.489 75.8339C90.5938 76.8602 92.1409 77.9845 93.2545 79.1415L100.775 71.903C98.654 69.6993 96.0421 67.904 93.0638 66.4517L88.489 75.8339ZM80.5266 73.2555C83.7939 73.9474 86.4233 74.8266 88.489 75.8339L93.0638 66.4517C90.0464 64.9804 86.5634 63.8643 82.6891 63.0438L80.5266 73.2555ZM77.3636 72.5777L80.5143 73.2528L82.7014 63.0464L79.5507 62.3713L77.3636 72.5777ZM73.2381 56.2009V67.4745H83.6762V56.2009H73.2381ZM85.142 53.7097C83.4794 52.299 81.5068 51.4998 79.5084 51.0889L77.4059 61.313C78.1425 61.4645 78.3754 61.6576 78.3888 61.6689L85.142 53.7097ZM88.8095 59.3414C88.1498 57.1237 86.9119 55.1888 85.1124 53.6848L78.4184 61.6938C78.5844 61.8326 78.7076 61.9912 78.8048 62.3176L88.8095 59.3414ZM85.9352 57.3853C86.8471 57.3853 87.5754 57.7551 88.0306 58.1527C88.4588 58.5266 88.6941 58.9532 88.8095 59.3414L78.8047 62.3176C79.5538 64.8355 81.972 67.8234 85.9352 67.8234V57.3853ZM98.9233 57.3853H85.9352V67.8234H98.9233V57.3853ZM95.6028 61.0849C95.4101 58.8335 97.2438 57.3853 98.9233 57.3853V67.8234C102.772 67.8234 106.381 64.6077 106.003 60.1948L95.6028 61.0849ZM93.3836 54.4203C94.6174 56.2898 95.3792 58.4726 95.6028 61.0849L106.003 60.1948C105.643 55.9852 104.362 52.1051 102.095 48.6706L93.3836 54.4203ZM86.7735 48.9168C89.7745 50.2929 91.8983 52.132 93.3616 54.3867L102.117 48.7042C99.4637 44.6155 95.7272 41.5394 91.1244 39.4287L86.7735 48.9168ZM78.0909 46.8673C81.525 47.1089 84.3914 47.8245 86.7735 48.9168L91.1244 39.4287C87.4152 37.7278 83.2871 36.769 78.8234 36.455L78.0909 46.8673ZM73.2381 37.8142V41.6611H83.6762V37.8142H73.2381ZM75.1952 39.7713C74.1143 39.7713 73.2381 38.8951 73.2381 37.8142H83.6762C83.6762 33.1302 79.8791 29.3332 75.1952 29.3332V39.7713ZM70.6715 51.2289C70.1525 51.3582 69.6361 51.5169 69.1283 51.7108L72.8516 61.4623C72.9307 61.4321 73.0432 61.3952 73.1951 61.3573L70.6715 51.2289ZM69.1773 51.6924C67.3932 52.3532 65.5941 53.438 64.2799 55.2072L72.659 61.4317C72.6077 61.5007 72.5597 61.5521 72.5227 61.5871C72.4862 61.6217 72.4644 61.6366 72.4659 61.6356C72.472 61.6314 72.5672 61.5679 72.8026 61.4807L69.1773 51.6924ZM64.2799 55.2072C63.0669 56.84 62.4452 58.735 62.401 60.724L72.8365 60.956C72.836 60.9768 72.8303 61.057 72.7922 61.1699C72.7535 61.2843 72.7009 61.3752 72.659 61.4317L64.2799 55.2072ZM62.4073 60.5583C62.3216 62.1427 62.5988 63.7621 63.3603 65.285L72.6964 60.6169C72.7545 60.7332 72.7927 60.8513 72.8131 60.9565C72.833 61.059 72.8303 61.1193 72.8302 61.1217L62.4073 60.5583ZM63.4586 65.4722C64.2612 66.9268 65.3957 68.0389 66.5939 68.8846L72.6134 60.357C72.5013 60.2779 72.4634 60.2363 72.4705 60.2439C72.4796 60.2535 72.5339 60.3136 72.598 60.4298L63.4586 65.4722ZM66.6794 68.9437C67.7159 69.6449 68.8689 70.2034 70.0564 70.6611L73.8103 60.9214C73.1399 60.663 72.7397 60.4412 72.528 60.298L66.6794 68.9437ZM77.1524 65.7912V56.2931H66.7143V65.7912H77.1524ZM73.2381 82.793V93.084H83.6762V82.793H73.2381ZM79.4522 98.2073C80.2479 98.0528 81.034 97.8422 81.7977 97.5621L78.2043 87.7621C78.0242 87.8281 77.7811 87.8988 77.4621 87.9607L79.4522 98.2073ZM81.7977 97.5621C83.7076 96.8618 85.5592 95.7421 86.9537 93.9877L78.7825 87.4927C78.8748 87.3766 78.8149 87.5382 78.2043 87.7621L81.7977 97.5621ZM86.9537 93.9877C88.3195 92.2695 89.0506 90.2294 89.0944 88.0404L78.6584 87.8317C78.6585 87.8228 78.6627 87.7551 78.6973 87.6589C78.732 87.5626 78.773 87.5046 78.7826 87.4926L86.9537 93.9877ZM89.0942 87.825C89.0481 85.6565 88.2951 83.6277 86.8622 81.956L78.937 88.749C78.8786 88.6808 78.7968 88.5599 78.7346 88.3953C78.6729 88.232 78.6597 88.1034 78.6585 88.0471L89.0942 87.825ZM86.964 82.0784C85.5847 80.3662 83.6825 79.2708 81.8874 78.5206L77.8625 88.1515C78.3328 88.348 78.6264 88.5136 78.7916 88.6237C78.9585 88.735 78.9345 88.7497 78.8353 88.6265L86.964 82.0784ZM81.9481 78.5464C81.3751 78.2984 80.7719 78.0687 80.1456 77.8546L76.7686 87.7314C77.1786 87.8715 77.5206 88.0039 77.8019 88.1257L81.9481 78.5464Z"
                fill="#043DE2"
                mask={`url(#path-2-outside-1_3443_25591-${idSuffix})`}
            />
            <path
                d="M132.175 39.9937L132.787 40.2201C132.786 40.2203 132.786 40.2206 132.786 40.2208L132.787 40.2201L132.175 39.9937ZM132.175 39.9937L132.401 40.6055C132.401 40.6055 132.402 40.6054 132.402 40.6053L132.401 40.6055L132.175 39.9937ZM128.569 17.4863C127.938 15.7824 125.528 15.7824 124.898 17.4863L120.784 28.6032L109.667 32.7168C107.963 33.3473 107.963 35.7573 109.667 36.3878L120.784 40.5014L124.898 51.6183C125.528 53.3222 127.938 53.3222 128.569 51.6183L132.682 40.5014L143.799 36.3878C145.503 35.7573 145.503 33.3473 143.799 32.7168L132.682 28.6032L128.569 17.4863ZM121.066 40.6055C121.065 40.6054 121.065 40.6053 121.065 40.6052L121.066 40.6055L121.292 39.9937L121.066 40.6055Z"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="2.60952"
            />
            <path
                d="M31.7081 120.237L32.3199 120.463C32.3198 120.464 32.3197 120.464 32.3196 120.464L32.3199 120.463L31.7081 120.237ZM31.7081 120.237L31.9345 120.849C31.9347 120.849 31.9349 120.849 31.9352 120.848L31.9345 120.849L31.7081 120.237ZM28.1022 97.7295C27.4717 96.0256 25.0617 96.0255 24.4312 97.7295L20.3175 108.846L9.20066 112.96C7.49675 113.59 7.49673 116 9.20066 116.631L20.3175 120.745L24.4312 131.861C25.0617 133.565 27.4717 133.565 28.1022 131.861L32.2158 120.745L43.3327 116.631C45.0366 116 45.0366 113.59 43.3327 112.96L32.2158 108.846L28.1022 97.7295ZM20.5989 120.849C20.5986 120.849 20.5982 120.848 20.5979 120.848L20.5989 120.849L20.8253 120.237L20.5989 120.849Z"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="2.60952"
            />
        </svg>
    )
}

export const WestRewardsLiftoutsIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="150" height="150" fill="white" />
            <path
                d="M122.68 133.553L113.253 142.98H32.5329L25.7571 140.328L22.5165 133.553L25.4625 126.777L32.5329 123.831L39.3086 127.072L42.5492 133.553H122.68Z"
                fill="#9BB1F3"
            />
            <mask id="path-2-inside-1_3443_1645" fill="white">
                <rect
                    x="40.192"
                    y="12.1797"
                    width="89.5579"
                    height="123.141"
                    rx="2.35677"
                />
            </mask>
            <rect
                x="40.192"
                y="12.1797"
                width="89.5579"
                height="123.141"
                rx="2.35677"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="7.07032"
                mask="url(#path-2-inside-1_3443_1645)"
            />
            <mask id="path-3-inside-2_3443_1645" fill="white">
                <rect
                    x="48.4408"
                    y="19.25"
                    width="73.0604"
                    height="61.8649"
                    rx="1.17839"
                />
            </mask>
            <rect
                x="48.4408"
                y="19.25"
                width="73.0604"
                height="61.8649"
                rx="1.17839"
                fill="#9BB1F3"
                stroke="#043DE2"
                strokeWidth="7.07032"
                mask="url(#path-3-inside-2_3443_1645)"
            />
            <mask id="path-4-inside-3_3443_1645" fill="white">
                <rect x="87" y="106" width="35" height="22" rx="1.17839" />
            </mask>
            <rect
                x="87"
                y="106"
                width="35"
                height="22"
                rx="1.17839"
                fill="#9BB1F3"
                stroke="#043DE2"
                strokeWidth="7.07032"
                mask="url(#path-4-inside-3_3443_1645)"
            />
            <line
                x1="50.2084"
                y1="88.7739"
                x2="80.8467"
                y2="88.7739"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
            />
            <line
                x1="50.2084"
                y1="98.2007"
                x2="80.8467"
                y2="98.2007"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
            />
            <line
                x1="89.0958"
                y1="88.7739"
                x2="119.734"
                y2="88.7739"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
            />
            <line
                x1="89.0958"
                y1="98.2007"
                x2="119.734"
                y2="98.2007"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
            />
            <line
                x1="50.2084"
                y1="107.628"
                x2="80.8467"
                y2="107.628"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
            />
            <line
                x1="50.2084"
                y1="117.056"
                x2="80.8467"
                y2="117.056"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
            />
            <line
                x1="50.2084"
                y1="126.482"
                x2="80.8467"
                y2="126.482"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
            />
            <path
                d="M22.5165 15.7144L22.5165 131.785"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M32.2393 142.98C30.3165 142.98 28.4369 142.41 26.8381 141.341C25.2394 140.273 23.9933 138.755 23.2575 136.979C22.5217 135.202 22.3292 133.247 22.7043 131.362C23.0794 129.476 24.0053 127.744 25.3649 126.384C26.7245 125.024 28.4568 124.099 30.3426 123.723C32.2285 123.348 34.1832 123.541 35.9596 124.277C37.736 125.012 39.2544 126.258 40.3226 127.857C41.3908 129.456 41.961 131.335 41.961 133.258"
                stroke="#043DE2"
                strokeWidth="3.53516"
            />
            <path
                d="M22.5175 14.2421C22.5175 12.9655 22.7689 11.7013 23.2575 10.5218C23.7461 9.34235 24.4622 8.27065 25.3649 7.36791C26.2677 6.46518 27.3394 5.74909 28.5189 5.26053C29.6984 4.77197 30.9626 4.52051 32.2393 4.52051C33.5159 4.52051 34.7801 4.77197 35.9596 5.26053C37.1391 5.74908 38.2108 6.46518 39.1136 7.36791C40.0163 8.27065 40.7324 9.34235 41.221 10.5218C41.7096 11.7013 41.961 12.9655 41.961 14.2421"
                stroke="#043DE2"
                strokeWidth="3.53516"
            />
            <path
                d="M76.7232 37.809C76.7232 43.1781 72.3707 47.5306 67.0015 47.5306C61.6323 47.5306 57.2797 43.1781 57.2797 37.809C57.2797 32.4399 61.6323 28.0874 67.0015 28.0874C72.3707 28.0874 76.7232 32.4399 76.7232 37.809Z"
                fill="#E6ECFC"
                stroke="#043DE2"
                strokeWidth="3.53516"
            />
            <path
                d="M31.9435 142.979L116.788 142.979"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M113.253 142.979L122.68 133.552"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M65.5301 54.6006L50.211 69.9196V79.3466H119.736V58.1358L98.2305 36.6304L72.8951 61.9655L65.5301 54.6006Z"
                fill="#E6ECFC"
            />
            <path
                d="M80.26 69.3304L72.895 61.9655M72.895 61.9655L65.5301 54.6006L50.211 69.9196V79.3466H119.736V58.1358L98.2305 36.6304L72.895 61.9655Z"
                stroke="#043DE2"
                strokeWidth="3.53516"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export const WestRewardsFreeEbooksIcon = (props: WestRewardsIconProps) => {
    return (
        <svg
            width={props.width}
            viewBox="0 0 150 150"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="150" height="150" fill="white" />
            <path
                d="M38 9.5L40 11.5V124.75H30.25L26.5 128.5V13.25L30.25 9.5H38Z"
                fill="#043DE2"
            />
            <path
                d="M120.5 133.75L122 126.5H40.25L32.75 124.25L27.5 127.5L26.25 133.75L28.75 138.25L32.75 140.25H122L120.5 133.75Z"
                fill="#E6ECFC"
            />
            <mask id="path-3-inside-1_3443_10490" fill="white">
                <rect x="38.5" y="10" width="88.5" height="118" rx="2" />
            </mask>
            <rect
                x="38.5"
                y="10"
                width="88.5"
                height="118"
                rx="2"
                fill="#9BB1F3"
                stroke="#043DE2"
                strokeWidth="6"
                mask="url(#path-3-inside-1_3443_10490)"
            />
            <rect
                x="52"
                y="26"
                width="61"
                height="61"
                rx="14.5"
                fill="white"
                stroke="#043DE2"
                strokeWidth="3"
            />
            <path
                d="M26 18.5L26 131.5"
                stroke="#043DE2"
                strokeWidth="3"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M34.25 140.5C32.8933 140.5 31.5575 140.165 30.361 139.526C29.1645 138.886 28.1441 137.962 27.3904 136.833C26.6366 135.705 26.1727 134.409 26.0397 133.059C25.9067 131.708 26.1088 130.346 26.628 129.093C27.1472 127.839 27.9675 126.733 29.0163 125.873C30.065 125.012 31.3099 124.423 32.6405 124.159C33.9712 123.894 35.3465 123.961 36.6448 124.355C37.9431 124.749 39.1243 125.457 40.0836 126.416"
                stroke="#043DE2"
                strokeWidth="3"
            />
            <path
                d="M26 17.25C26 15.6183 26.4839 14.0233 27.3904 12.6665C28.2969 11.3098 29.5854 10.2524 31.0929 9.62799C32.6004 9.00357 34.2592 8.84019 35.8595 9.15852C37.4598 9.47685 38.9298 10.2626 40.0836 11.4164"
                stroke="#043DE2"
                strokeWidth="3"
            />
            <path
                d="M34 140.5H125.5"
                stroke="#043DE2"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M122.5 126.5C122.5 126.5 120.5 129.5 120.5 133.5C120.5 137.5 122.5 140.5 122.5 140.5"
                stroke="#043DE2"
                strokeWidth="3"
            />
            <line
                x1="69.5"
                y1="100.5"
                x2="95.5"
                y2="100.5"
                stroke="#043DE2"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <line
                x1="69.5"
                y1="108.5"
                x2="95.5"
                y2="108.5"
                stroke="#043DE2"
                strokeWidth="3"
                strokeLinecap="round"
            />
            <circle
                cx="82.5"
                cy="56.5"
                r="20.5"
                stroke="#043DE2"
                strokeWidth="3"
            />
            <path
                d="M82.5 36C82.5 36 71.5 40.7788 71.5 56.75C71.5 72.7212 82.5 77.5 82.5 77.5"
                stroke="#043DE2"
                strokeWidth="2"
            />
            <path
                d="M97 71.5C97 71.5 93.6606 67.5 82.5 67.5C71.3394 67.5 68 71.5 68 71.5"
                stroke="#043DE2"
                strokeWidth="2"
            />
            <path
                d="M82.5 36C82.5 36 93.5 40.7788 93.5 56.75C93.5 72.7212 82.5 77.5 82.5 77.5"
                stroke="#043DE2"
                strokeWidth="2"
            />
            <path
                d="M97 41.5C97 41.5 93.6606 45.5 82.5 45.5C71.3394 45.5 68 41.5 68 41.5"
                stroke="#043DE2"
                strokeWidth="2"
            />
            <path d="M82.75 36V77" stroke="#043DE2" strokeWidth="2" />
            <path d="M62 57H103" stroke="#043DE2" strokeWidth="2" />
        </svg>
    )
}

export const WestRewardsDividerVectorGray = () => {
    return (
        <svg
            viewBox="0 0 839 75"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g opacity="0.5" filter="url(#filter0_d_2073_27984)">
                <path
                    d="M410.141 22.6303C609.54 22.6303 807.008 52.0252 839 67V1H5C39.1984 7.10084 169.097 22.6303 410.141 22.6303Z"
                    fill="#1C204F"
                />
                <path
                    d="M410.141 22.6303C609.54 22.6303 807.008 52.0252 839 67V1H5C39.1984 7.10084 169.097 22.6303 410.141 22.6303Z"
                    stroke="black"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_2073_27984"
                    x="0.912109"
                    y="0.5"
                    width="842.588"
                    height="75.2861"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2073_27984"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2073_27984"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    )
}

export const WestRewardsDividerVectorPurple = () => {
    return (
        <svg
            viewBox="4.5 0.5 844 76"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g filter="url(#filter0_d_2073_27983)">
                <path
                    d="M433.859 22.6303C234.46 22.6303 36.9921 52.0252 5 67V1H839C804.802 7.10084 674.903 22.6303 433.859 22.6303Z"
                    fill="url(#paint0_linear_2073_27983)"
                />
                <path
                    d="M433.859 22.6303C234.46 22.6303 36.9921 52.0252 5 67V1H839C804.802 7.10084 674.903 22.6303 433.859 22.6303Z"
                    stroke="black"
                    strokeLinecap="round"
                />
                <path
                    d="M433.859 22.6303C234.46 22.6303 36.9921 52.0252 5 67V1H839C804.802 7.10084 674.903 22.6303 433.859 22.6303Z"
                    stroke="black"
                    strokeOpacity="0.2"
                    strokeLinecap="round"
                />
            </g>
            <defs>
                <filter
                    id="filter0_d_2073_27983"
                    x="0.5"
                    y="0.5"
                    width="842.588"
                    height="75.2861"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_2073_27983"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_2073_27983"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear_2073_27983"
                    x1="844.096"
                    y1="33.9998"
                    x2="5"
                    y2="34"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DC01BE" />
                    <stop offset="1" stopColor="#AA01E1" />
                </linearGradient>
            </defs>
        </svg>
    )
}
